import { openDrawer } from "@/src/components/dialogs";
import { UploadCards } from "@/src/components/uploadSpots";
import { Patient, Appointment, Exam } from "@/src/data/allTypes";
import { USER } from "@/src/data/globalVariables";
import apiFetch from "@/src/utils/apiFetch";
import {
  jsonAbstract,
  getItemId,
  getUserId,
  openToast,
} from "@/src/utils/utils";
import { getStandardConfidentiality } from "../patients/confidentialitiesHook";
import { PatientExamForm } from "./patientExamForm";

export async function openExam(
  patient: Patient,
  appointment: Appointment,
  onConfirm: (appointment: Appointment) => void
) {
  const referenceId = getItemId(appointment.type?.exam) as string;

  let reference = await apiFetch("references", "loadOne", {
    referenceId,
  });

  if (!reference) return alert("Type d'examen non défini");

  let exam: Exam | null | undefined = null;
  if (appointment.item) {
    let folderItem = await apiFetch("appointments", "loadAppointmentItem", {
      appointmentId: appointment.id,
      itemId: getItemId(appointment.item),
    });
    if (folderItem?.type == "exam") exam = folderItem;
  }

  exam ||= {
    type: "exam",
    creator: USER?.get(),
    patient: appointment.patient,
    uploads: [],
    notes: "",
    conclusion: "",
    reference,
    status: "pending",
    confidentiality: getStandardConfidentiality(patient),
    readBy: [],
    content: {
      patient: appointment.patient,
      reference,
      fieldAnswers: [],
      creator: getUserId(),
    },
  };

  await openDrawer({
    title: `${exam.reference?.name} - ${exam.patient?.firstName} ${exam.patient?.lastName}`,
    additionalClasses: ["medium"],
    content: (
      <div className="c1 gap20">
        {((appointment?.notes?.length || 0) > 0 ||
          (appointment?.uploads?.length || 0) > 0) && (
          <div className="c1 gap10 br blueish p10">
            <div className="bold">Demande</div>
            <div>{appointment.notes}</div>
            <UploadCards uploads={appointment.uploads}></UploadCards>
          </div>
        )}
        <PatientExamForm
          reference={exam.reference}
          patient={patient}
          current={exam}
          onChange={(newValue) => {
            exam = newValue;
          }}
        />
      </div>
    ),
    onConfirm: async () => {
      if (!exam) throw new Error("Error Exams is undefined");
      exam.status = "finished";

      let result = await apiFetch("exams", "addOne", { exam });
      if (!result) return;
      exam = result;
      let appointmentResult = await apiFetch("appointments", "addOne", {
        shouldReinitializeReadBy: true,
        appointment: {
          ...appointment,
          item: jsonAbstract(exam.id),
          status: "finished",
        },
      });
      if (!appointmentResult) return;
      openToast("success", "Résultat ajouté avec succès");
      onConfirm(appointmentResult);
    },
  });
}
